const productConstants = {
  PRODUCT_LIST_REQUEST: 'PRODUCT_LIST_REQUEST',
  PRODUCT_LIST_SUCCCESS: 'PRODUCT_LIST_SUCCCESS',
  PRODUCT_LIST_FAIL: 'PRODUCT_LIST_FAIL',
  PRODUCT_DETAILS_REQUEST: 'PRODUCT_DETAILS_REQUEST',
  PRODUCT_DETAILS_SUCCESS: 'PRODUCT_DETAILS_SUCCESS',
  PRODUCT_DETAILS_FAIL: 'PRODUCT_DETAILS_FAIL',

  PRODUCT_ADD_REVIEW: 'PRODUCT_ADD_REVIEW',
};

export default productConstants;
